module.exports = __webpack_public_path__ + "img/intro-1.1b462a97.png";